// extracted by mini-css-extract-plugin
export default {"workspace":"style_workspace__vXFe-","btn":"style_btn__6HRxn"};